import {apiPath} from "@pg-mono/rp-api-routes";
import {createTurnstileRtkError} from "@pg-mono/turnstile";

import {rpApi} from "../../app/api/rp_api";
import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {appendTurnstileToken} from "../../app/turnstile";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {isRtkqError} from "../../store/utils/is_rtkq_error";
import {IApplicationData} from "../types/IApplicationData";
import {IPostMultipleApplicationsPayload} from "../types/lead/IPostMultipleApplicaitonsPayload";

export const createMultipleLeadsApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        createMultipleApplications: build.mutation<
            {
                applications: IApplicationData[];
            },
            IPostMultipleApplicationsPayload
        >({
            queryFn: async (body, _api, _extraOptions, baseQuery) => {
                try {
                    const payload = await appendTurnstileToken(body, TurnstileAction.APPLICATION_MULTIPLE);
                    const result = await baseQuery({
                        url: apiPath.applications.createMultiple.base,
                        method: "POST",
                        body: payload
                    });

                    if (result.error) {
                        return {error: result.error};
                    }

                    return {data: result.data as {applications: IApplicationData[]}};
                } catch (_error) {
                    return {error: createTurnstileRtkError()};
                }
            },
            async onQueryStarted(_, {queryFulfilled}) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    if (isRtkqError(error) && error.status === 403) {
                        notifyBugsnag(error, "createMultipleLeads: catch 403", error.data);
                    }
                }
            }
        })
    })
});

export const {
    useCreateMultipleApplicationsMutation,
    endpoints: {createMultipleApplications}
} = createMultipleLeadsApi;
import {apiPath} from "@pg-mono/rp-api-routes";
import {createTurnstileRtkError} from "@pg-mono/turnstile";

import {rpApi} from "../../app/api/rp_api";
import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {appendTurnstileToken} from "../../app/turnstile";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {isRtkqError} from "../../store/utils/is_rtkq_error";
import {IApplicationData} from "../types/IApplicationData";
import {IPostMultipleApplicationsPayload} from "../types/lead/IPostMultipleApplicaitonsPayload";

export const createMultipleLeadsApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        createMultipleApplications: build.mutation<
            {
                applications: IApplicationData[];
            },
            IPostMultipleApplicationsPayload
        >({
            queryFn: async (body, _api, _extraOptions, baseQuery) => {
                try {
                    const payload = await appendTurnstileToken(body, TurnstileAction.APPLICATION_MULTIPLE);
                    const result = await baseQuery({
                        url: apiPath.applications.createMultiple.base,
                        method: "POST",
                        body: payload
                    });

                    if (result.error) {
                        return {error: result.error};
                    }

                    return {data: result.data as {applications: IApplicationData[]}};
                } catch (_error) {
                    return {error: createTurnstileRtkError()};
                }
            },
            async onQueryStarted(_, {queryFulfilled}) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    if (isRtkqError(error) && error.status === 403) {
                        notifyBugsnag(error, "createMultipleLeads: catch 403", error.data);
                    }
                }
            }
        })
    })
});

export const {
    useCreateMultipleApplicationsMutation,
    endpoints: {createMultipleApplications}
} = createMultipleLeadsApi;
